let animateCartMessageId = null;

function makeItMarquee(){
    const containers = window.document.querySelectorAll('.js_marquee-container');

    if( containers.length < 1) return;

    containers.forEach(container => {
        const wrapper = container.querySelector('.js_marquee_text');
        let text = wrapper?.firstElementChild;
    
        let elementWidth = wrapper.offsetWidth;
        let parentWidth = container.offsetWidth;
        let textWidth = text.offsetWidth;
        let flag = 0,firstRender = false;
        clone = text?.cloneNode(true);
        animateCartMessageId = setInterval(() => {
            
            wrapper.style.marginLeft = --flag + "px";
            if (-flag == Math.floor(elementWidth * 0.30) && !firstRender){                
                clone.style.paddingLeft = Math.floor(elementWidth * 0.15) + 'px';
                wrapper?.appendChild(clone)
            }

            if ( -flag == (textWidth + Math.floor(elementWidth * 0.15) + Math.floor(elementWidth * 0.30))){
                const removed = wrapper?.removeChild(wrapper.firstElementChild);
                removed.style.paddingLeft = Math.floor(elementWidth * 0.15) + 'px'
                wrapper?.appendChild(removed);
                flag = - Math.floor(elementWidth * 0.30);
            }
        }, 30);

    })


}

document.addEventListener('theme:cart:open',makeItMarquee);
document.addEventListener('theme:cart:close',()=>clearInterval(animateCartMessageId));
